<div class="login-form-wrapper">

  <div class="side-left">
    <div class="wave-wrapper">
      <svg class="waves" xmlns="http://www.w3.org/2000/svg" viewBox="0 24 150 28" preserveAspectRatio="none">
        <defs>
          <linearGradient id="wave-gradient" gradientTransform="rotate(90)">
            <stop offset="5%" stop-color="#4286f4" />
            <stop offset="35%" stop-color="#373b44" />
          </linearGradient>
          <path id="a" d="M-160 44c30 0 58-6 88-6s58 6 88 6 58-6 88-6 58 6 88 6v44h-352z" />

        </defs>
        <g class="wave-paths">
          <use xlink:href="#a" x="0" />
          <use xlink:href="#a" x="50" y="3" />
        </g>
      </svg>
    </div>


    <div class="login-card">
      <img *ngIf="ImageUrl" [src]="ImageUrl" alt="login image" class="login-card-image" />

      <!-- <h6 class="logintitle">{{ 'loginComponent.title' | translate }}</h6> -->
      <img src="assets/icons/logo-removebg-preview.png" />

      <form class="login-form" (submit)="onSubmit($event)">
        <dx-form [formData]="formData" [disabled]="loading">

          <dxi-item dataField="UserName" editorType="dxTextBox"
            [editorOptions]="{stylingMode: 'filled', placeholder: 'loginComponent.username' | translate, mode: 'UserName'}">
            <dxi-validation-rule type="required" message="{{ 'errors.required' | translate }}"></dxi-validation-rule>
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>

          <dxi-item dataField="Password" editorType="dxTextBox"
            [editorOptions]="{stylingMode: 'filled', placeholder: 'loginComponent.Password' | translate, mode: 'Password'}">
            <dxi-validation-rule type="required" message="{{ 'errors.required' | translate }}"></dxi-validation-rule>
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>

          <dxi-item dataField="rememberMe" editorType="dxCheckBox"
            [editorOptions]="{text: 'loginComponent.remember' | translate, elementAttr: { class: 'form-text' } }">
            <dxo-label [visible]="false"></dxo-label>
          </dxi-item>

          <dxi-item itemType="button">
            <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'signInTemplate'">
            </dxo-button-options>
          </dxi-item>

          <ng-container *dxTemplate="let item of 'signInTemplate'">
            <div>
              <span class="dx-button-text">{{ 'loginComponent.title' | translate }}</span>
            </div>
          </ng-container>

        </dx-form>
      </form>
    </div>
  </div>

  <!-- <div class="side-right">
    <img [src]="imgarray[currentIndex]" alt="ERP background" />
  </div> -->
</div>